<po-page-default p-title="Certificado Digital" [p-breadcrumb]="breadcrumb"
    p-subtitle="Envio e validação de certificados digitais para integração com sistemas externos">
    <div class="po-row">
        <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
            <span class="an an-robot"></span>
            Certificado Digital</span>

        <div class="po-row">
            <po-container class="po-lg-12 po-md-12 po-sm-12">
                <div class="po-lg-11 po-md-9 po-sm-8">
                    <p class="po-font-subtitle">Certificado Digital</p>
                    <br />
                </div>
                <div class="po-row three-columns-container">
                    <div class="po-lg-4 c1">
                        <po-upload #uploadCertificado [p-drag-drop]="true"
                            [p-multiple]="false" [p-drag-drop-height]="150" [p-url]="urlPlaceholder" 
                            [p-hide-send-button]="true" p-label="Selecione ou arraste o arquivo do certificado digital">
                        </po-upload>
                        <div class="senha-enviar-wrapper po-mt-2">
                            <po-input p-label="Senha" [(ngModel)]="senha" p-placeholder="Informe a senha do certificado" class="po-flex-1"></po-input>
                            <po-button p-label="Enviar Certificado" (p-click)="enviarCertificado()" [p-disabled]="!isBotaoHabilitado" [p-loading]="isLoading"></po-button>
                        </div>
                    </div>
                    <div class="po-lg-4 c2 certificado-info-table">
                        <div class="info-row">
                            <span class="info-label">.    Titular:</span>
                            <span class="info-value">{{ titular || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Razão Social:</span>
                            <span class="info-value">{{ razaoSocial || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Nome fantasia:</span>
                            <span class="info-value">{{ nomeFantasia || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    CNPJ:</span>
                            <span class="info-value">{{ cnpj || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Emissor:</span>
                            <span class="info-value">{{ emissor || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Data de Emissão:</span>
                            <span class="info-value">{{ dataEmissao || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Data de Validade:</span>
                            <span class="info-value">{{ dataValidade || '(---)' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">.    Serial:</span>
                            <span class="info-value">{{ serial || '(---)' }}</span>
                        </div>
                    </div>
                </div>
            </po-container>
        </div>
    </div>
</po-page-default>

